var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-preview"},[_c('img',{staticClass:"image-preview__image",attrs:{"src":_vm.imageSrc,"alt":_vm.imageAlt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }